export default class NotificationsTableController {
    /* @ngInject */
    constructor($log, $location, $routeParams, EventsService) {
        this.$log = $log;
        this.$location = $location;
        this.$routeParams = $routeParams;
        this.EventsService = EventsService;

        this.events = [];
        this.currentPage = 0;
        this.itemsPerPage = 7;
        this.isLoading = true;
    }

    $onChanges() {
        this.getEvents();
    }

    getEvents() {
        const params = {
            thingId: this.$routeParams.id,
            fromDate: this.fromDate,
            toDate: this.toDate,
        };
        this.isLoading = true;
        this.EventsService.getEvents(params)
            .then((response) => {
                this.events = response.hits.hits;
            })
            .catch((error) => {
                this.$log.info(`Error getting events: ${error}`);
                this.$location.path('/login');
            })
            .finally(() => {
                this.isLoading = false;
            });
    }

    isEmpty() {
        return this.events && this.events.length === 0;
    }

    eventsForCurrentPage() {
        return this.events.slice(this.currentPage * this.itemsPerPage,
            (this.currentPage * this.itemsPerPage) + this.itemsPerPage);
    }

    numberOfPages() {
        return Math.ceil(this.events.length / this.itemsPerPage);
    }

    previousPage() {
        if (this.currentPage > 0) {
            this.currentPage = this.currentPage - 1;
        }
    }

    nextPage() {
        if (this.currentPage < (this.numberOfPages() - 1)) {
            this.currentPage = this.currentPage + 1;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/detail/notifications-table/notifications-table.controller.js